import React from 'react';
import { CONTEXT_KEY } from './constants';
const FallbackContext = /*#__PURE__*/React.createContext({
  type: 'not-passed'
});
export const useSlotContext = () => {
  const SlotContext =
  // @ts-expect-error
  self[CONTEXT_KEY];
  return React.useContext(SlotContext != null ? SlotContext : FallbackContext);
};
//# sourceMappingURL=useSlotContext.js.map